// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mine-list-container[data-v-1458215e]{margin-top:23.73333vw}.mine-list-container .mine-list[data-v-1458215e]{background-color:#fff;border-radius:1.6vw;box-sizing:border-box;padding:2.4vw 5.6vw 2.4vw;margin-top:3.2vw}", ""]);
// Exports
module.exports = exports;
